module.exports = __webpack_public_path__ + "img/img5.ffe94764.jpg";